import { render, staticRenderFns } from "./SessionPatternListField.vue?vue&type=template&id=23264298&lang=pug&"
import script from "./SessionPatternListField.vue?vue&type=script&lang=js&"
export * from "./SessionPatternListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23264298')) {
      api.createRecord('23264298', component.options)
    } else {
      api.reload('23264298', component.options)
    }
    module.hot.accept("./SessionPatternListField.vue?vue&type=template&id=23264298&lang=pug&", function () {
      api.rerender('23264298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/SessionPatternListField.vue"
export default component.exports